'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThemeNoBrushIcon = function ThemeNoBrushIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 10.78 10.78' }, props),
        _react2.default.createElement('path', { 'class': 'cls-1', d: 'M5.39 0a5.39 5.39 0 0 0 0 10.78.92.92 0 0 0 .9-.9.77.77 0 0 0-.24-.6 1.07 1.07 0 0 1-.24-.6.92.92 0 0 1 .9-.9h1.07a3 3 0 0 0 3-3C10.78 2.16 8.38 0 5.39 0zM2.1 5.39a.92.92 0 0 1-.9-.9.92.92 0 0 1 .9-.9.9.9 0 0 1 0 1.8zM3.89 3A.92.92 0 0 1 3 2.1a.92.92 0 0 1 .9-.9.92.92 0 0 1 .9.9.92.92 0 0 1-.91.9zm3 0A.92.92 0 0 1 6 2.1a.9.9 0 1 1 1.79 0 .92.92 0 0 1-.9.9zm1.79 2.4a.92.92 0 0 1-.9-.9.9.9 0 1 1 1.8 0 .92.92 0 0 1-.9.89z' })
    );
};

exports.default = ThemeNoBrushIcon;